import React from 'react';
import UserForms from '../../forms';
import UserActionItems from '../fields';
import Icons from 'components/icons';
import { ModalStandard, Localize } from 'components/service';
import { TUser } from 'components/user/helpers/user-types-helper';
import { usePermissionByObject } from 'components/permissions';
import Users from 'components/user';
import { Tooltip } from 'antd';
import { localizeByKeyStatic } from 'components/service';
import './user-action-list.scss';

interface IUserActionListProps
{
  userID: TUser[ 'id' ];
}

const UserActionList: React.FC<IUserActionListProps> = ({ userID }) =>
{
  const { hasPermission: hasChangePasswordPermission } = usePermissionByObject(Users.Const.permissions.CHANGE_PASSWORD);

  return (
    <ul className="action-list indents">
      <Tooltip
        title={!hasChangePasswordPermission ? `${localizeByKeyStatic('PERMISSION.Error_AccessDenied')}: ${localizeByKeyStatic(Users.Const.permissions.CHANGE_PASSWORD.slug)}` : undefined}
      >
        <li>
          <ModalStandard
            width={400}
            disabled={!hasChangePasswordPermission}
            modalButton={
              <div className={!hasChangePasswordPermission ? 'disabled' : ''}>
                <Icons.SendPass />
                <span>
                  <Localize>FORMS.Title_SendPassword</Localize>
                </span>
              </div>
            }
          >
            <UserActionItems.SendPass userID={userID} action={() => { }} />
          </ModalStandard>
        </li>
      </Tooltip>

      <Tooltip
        title={!hasChangePasswordPermission ? `${localizeByKeyStatic('PERMISSION.Error_AccessDenied')}: ${localizeByKeyStatic(Users.Const.permissions.CHANGE_PASSWORD.slug)}` : undefined}
      >
        <li>
          <ModalStandard
            disabled={!hasChangePasswordPermission}
            width={400}
            extraClass={"modal-form"}
            modalButton={
              <div className={!hasChangePasswordPermission ? 'disabled' : ''}>
                <Icons.ChangePass />
                <span>
                  <Localize>FORMS.Title_ChangePassword</Localize>
                </span>
              </div>
            }
            modalTitle={
              <strong className="modal-title">
                <span className="text">
                  <Localize>FORMS.Title_ChangePassword</Localize>
                </span>
              </strong>
            }
          >
            <UserForms.ChangePassword userID={userID} action={() => { }} />
          </ModalStandard>
        </li>
      </Tooltip>
    </ul>
  );
};

export default UserActionList;